import * as React from 'react';
import { Report9BoxDataService } from '../../../services';
import { Report9BoxSettings, Report9BoxText } from '../../../models';
import { PVAContentHeader, PVAContentBody, PonderaEditModal } from '../../../components';
import { BaseRouteProps } from '../../../interfaces';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { FilterStore } from '../../../stores';
import './9box.css';
import { Form, Text, FormApi } from 'react-form';

class Report9BoxSettingsSimple {
    box1: Report9BoxText;
    box1Desc: Report9BoxText;
    box1Color: string;
    box2: Report9BoxText;
    box2Desc: Report9BoxText;
    box2Color: string;
    box3: Report9BoxText;
    box3Desc: Report9BoxText;
    box3Color: string;
    box4: Report9BoxText;
    box4Desc: Report9BoxText;
    box4Color: string;
    box5: Report9BoxText;
    box5Desc: Report9BoxText;
    box5Color: string;
    box6: Report9BoxText;
    box6Desc: Report9BoxText;
    box6Color: string;
    box7: Report9BoxText;
    box7Desc: Report9BoxText;
    box7Color: string;
    box8: Report9BoxText;
    box8Desc: Report9BoxText;
    box8Color: string;
    box9: Report9BoxText;
    box9Desc: Report9BoxText;
    box9Color: string;
    xScale1: Report9BoxText;
    xScale2: Report9BoxText;
    xScale3: Report9BoxText;
    xArrow: Report9BoxText;
    yScale1: Report9BoxText;
    yScale2: Report9BoxText;
    yScale3: Report9BoxText;
    yArrow: Report9BoxText;
}

interface Settings9BoxEditState {
    orgId: number;
    reportSettings: Report9BoxSettingsSimple | undefined;
    showModal: boolean[];
}

interface Settings9BoxProps extends BaseRouteProps<{}> {
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class Settings9BoxView extends React.Component<Settings9BoxProps, Settings9BoxEditState> {
    private report9BoxDataService = new Report9BoxDataService(this.props.notificationService);
    private formApi: FormApi;

    private defaultBoxValues = [
        { // box 1
            title: 'Consistent Star',
            color: '#87d6d6',
            desc: '<ul><li>Very Strong Performer</li><li>Is or has potential to move up to a senior leadership position</li></ul>'
        },
        { // box 2
            title: 'Current Star',
            color: '#87d6d6',
            desc: '<ul><li>Valuable contributor to the business</li><li>Can play a significant role at higher position in the organization</li></ul>'
        },
        { // box 3
            title: 'Future Star',
            color: '#87d6d6',
            desc: '<ul><li>Solid performer with room to grow in current assignment</li><li>Is or has potential to move up to a senior leadership position</li></ul>'
        },
        { // box 4
            title: 'Expert Individual Performer',
            color: '#deaeff',
            desc: '<ul><li>Seasoned professional (difficult to replace)</li><li>Not promotable yet very valuable</li> <li>May be called upon to assist with other opportunities</li></ul>'
        },
        { // box 5
            title: 'Key Player',
            color: '#b8e3a8',
            desc: '<ul><li>Good Performer with room to grow at current level</li><li>May be promotable in the future</li></ul>'
        },
        { // box 6
            title: 'Diamond in the Rough',
            color: '#b8e3a8',
            desc: '<ul><li>Exceeded expectations in his/her last job yet recently promoted</li><li>Requires some time and experience coupled with coaching to reach full performance</li><li>Is or has potential to move up to a senior leadership position</li></ul>'
        },
        { // box 7
            title: 'Reliable Employee',
            color: '#fed181',
            desc: '<ul><li>Competent yet currently not promotable</li></ul>'
        },
        { // box 8
            title: 'New Player',
            color: '#fed181',
            desc: '<ul><li>Person has ability to develop skills</li><li>New to position</li><li>May be promotable in the future</li></ul>'
        },
        { // box 9
            title: 'Talent Risk',
            color: '#f9aeae',
            desc: '<ul><li>Performing below expectations</li><li>Requires action- fix or replace</li></ul>'
        },
    ];

    private defaultXScales = {
        Scale1: 'Room to Develop/Improve',
        Scale2: 'Solid Performers',
        Scale3: 'Exceptional Performers',
        Arrow: 'Performance'
    };

    private defaultYScales = {
        Scale1: 'Highly Promotable',
        Scale2: 'Promotable',
        Scale3: 'Not Promotable',
        Arrow: 'Promotability'
    };

    constructor(props: Settings9BoxProps) {
        super(props);

        this.state = {
            orgId: 0,
            reportSettings: undefined,
            showModal: [false, false, false, false, false, false, false, false, false]
        };
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    keyValue(data: Report9BoxSettings, key: string) {
        if (data.report9BoxTexts) {
            var val = data.report9BoxTexts.find((t: Report9BoxText) => {
                return t.contentKey === key;
            });
            if (val) {
                return val;
            }
        }

        var empty = new Report9BoxText();
        empty.contentKey = key;
        empty.value = '';
        empty.languageId = 1;
        return empty;
    }

    update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.setState({
                orgId: this.organization.id,
                reportSettings: undefined
            });

            this.report9BoxDataService.getConfig(this.organization).then((settings: Report9BoxSettings) => {
                var simpleSettings = new Report9BoxSettingsSimple();
                simpleSettings.box1Color = settings.box1Color;
                simpleSettings.box2Color = settings.box2Color;
                simpleSettings.box3Color = settings.box3Color;
                simpleSettings.box4Color = settings.box4Color;
                simpleSettings.box5Color = settings.box5Color;
                simpleSettings.box6Color = settings.box6Color;
                simpleSettings.box7Color = settings.box7Color;
                simpleSettings.box8Color = settings.box8Color;
                simpleSettings.box9Color = settings.box9Color;
                simpleSettings.box1 = this.keyValue(settings, 'box1');
                simpleSettings.box2 = this.keyValue(settings, 'box2');
                simpleSettings.box3 = this.keyValue(settings, 'box3');
                simpleSettings.box4 = this.keyValue(settings, 'box4');
                simpleSettings.box5 = this.keyValue(settings, 'box5');
                simpleSettings.box6 = this.keyValue(settings, 'box6');
                simpleSettings.box7 = this.keyValue(settings, 'box7');
                simpleSettings.box8 = this.keyValue(settings, 'box8');
                simpleSettings.box9 = this.keyValue(settings, 'box9');
                simpleSettings.box1Desc = this.keyValue(settings, 'box1Desc');
                simpleSettings.box2Desc = this.keyValue(settings, 'box2Desc');
                simpleSettings.box3Desc = this.keyValue(settings, 'box3Desc');
                simpleSettings.box4Desc = this.keyValue(settings, 'box4Desc');
                simpleSettings.box5Desc = this.keyValue(settings, 'box5Desc');
                simpleSettings.box6Desc = this.keyValue(settings, 'box6Desc');
                simpleSettings.box7Desc = this.keyValue(settings, 'box7Desc');
                simpleSettings.box8Desc = this.keyValue(settings, 'box8Desc');
                simpleSettings.box9Desc = this.keyValue(settings, 'box9Desc');
                simpleSettings.xScale1 = this.keyValue(settings, 'xScale1');
                simpleSettings.xScale2 = this.keyValue(settings, 'xScale2');
                simpleSettings.xScale3 = this.keyValue(settings, 'xScale3');
                simpleSettings.xArrow = this.keyValue(settings, 'xArrow');
                simpleSettings.yScale1 = this.keyValue(settings, 'yScale1');
                simpleSettings.yScale2 = this.keyValue(settings, 'yScale2');
                simpleSettings.yScale3 = this.keyValue(settings, 'yScale3');
                simpleSettings.yArrow = this.keyValue(settings, 'yArrow');

                this.setState({
                    reportSettings: simpleSettings
                });
            });
        }
    }

    public componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    save(values: any) {
        if (!this.organization) {
            return;
        }

        // simple to complex
        var complex = new Report9BoxSettings();
        complex.box1Color = values.box1Color;
        complex.box2Color = values.box2Color;
        complex.box3Color = values.box3Color;
        complex.box4Color = values.box4Color;
        complex.box5Color = values.box5Color;
        complex.box6Color = values.box6Color;
        complex.box7Color = values.box7Color;
        complex.box8Color = values.box8Color;
        complex.box9Color = values.box9Color;
        complex.report9BoxTexts = [
            values.box1,
            values.box1Desc,
            values.box2,
            values.box2Desc,
            values.box3,
            values.box3Desc,
            values.box4,
            values.box4Desc,
            values.box5,
            values.box5Desc,
            values.box6,
            values.box6Desc,
            values.box7,
            values.box7Desc,
            values.box8,
            values.box8Desc,
            values.box9,
            values.box9Desc,
            values.xScale1,
            values.xScale2,
            values.xScale3,
            values.xArrow,
            values.yScale1,
            values.yScale2,
            values.yScale3,
            values.yArrow
        ];

        this.report9BoxDataService.updateConfig(this.organization, complex).then((success) => {
            this.props.notificationService.addNotification(`Saved successfully.`);
        });
    }

    updateModalState = (boxNumber: number) => {
        const { showModal } = this.state;
        showModal[boxNumber - 1] = true;
        this.setState({showModal: showModal});
    }

    generateBox(box: number) {
        const boxDefaultValues = this.defaultBoxValues[box - 1];

        const modalProps = {
            show: this.state.showModal[box - 1] === true,
            onHide: (data: string) => {
                const { showModal } = this.state;
                showModal[box - 1] = false;
                this.setState({showModal: showModal});

                let currentDescriptionItem = this.formApi.values[`box${box}Desc`];
                currentDescriptionItem.value = data;
                this.formApi.setValue(`box${box}Desc`, currentDescriptionItem);
                this.forceUpdate();
            },
            title: `Box ${box} Description`,
            content: this.formApi.values[`box${box}Desc`] ? this.formApi.values[`box${box}Desc`].value : '',
            defaultContent: boxDefaultValues.desc
        };

        return (
            <div key={`box-${box}`} className="col-xs-4">
                <div className="form-group box9-edit">
                    <label htmlFor="name">{box}. Title</label>
                    <Text className="form-control" placeholder={boxDefaultValues.title} field={[`box${box}`, 'value']} id={`box${box}`} />
                    <label htmlFor="name">Color</label>
                    <Text className="form-control" placeholder={`Hex Value (e.g. ${boxDefaultValues.color})`} field={`box${box}Color`} id={`box${box}Color`} />
                    <br />
                    <a className="btn btn-default" onClick={() => { this.updateModalState(box); }}>View/Edit</a>
                    <PonderaEditModal {...modalProps} />
                </div>
            </div>);
    }

    setFormApi = (api: FormApi) => {
        this.formApi = api;
    }

    public render() {
        if (!this.organization) {
            return <div />;
        }

        return (
            <div>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                
                <PVAContentHeader>
                    <div className="title">
                        9 Box Settings <span className="light">for </span>
                        {this.organization && <span>'{this.organization.name}'</span>}
                    </div>
                </PVAContentHeader>

                <PVAContentBody>
                    
                    {this.state.reportSettings && <Form
                        defaultValues={this.state.reportSettings}
                        onSubmit={submittedValues => this.save(submittedValues)}
                        getApi={this.setFormApi}
                    >
                        {formApi => (
                            <form onSubmit={formApi.submitForm} id="entityForm">
                                <h3>Boxes</h3>
                                
                                <div className="row">
                                    {[6, 3, 1].map((box: number) => {
                                        return this.generateBox(box);
                                    })}
                                </div>

                                <div className="row">
                                    {[8, 5, 2].map((box: number) => {
                                        return this.generateBox(box);
                                    })}
                                </div>

                                <div className="row">
                                    {[9, 7, 4].map((box: number) => {
                                        return this.generateBox(box);
                                    })}
                                </div>

                                <h3>X Scale</h3>
                                <div className="row">
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultXScales.Scale1} field="xScale1.value" id="XScale1" />
                                    </div>
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultXScales.Scale2} field="xScale2.value" id="XScale2" />
                                    </div>
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultXScales.Scale3} field="xScale3.value" id="XScale3" />
                                    </div>
                                </div>

                                <h3>X Arrow</h3>
                                <div className="row">
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultXScales.Arrow} field="xArrow.value" id="XArrow" />
                                    </div>
                                </div>

                                <h3>Y Scale</h3>
                                <div className="row">
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultYScales.Scale1} field="yScale1.value" id="YScale1" />
                                    </div>
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultYScales.Scale2} field="yScale2.value" id="YScale2" />
                                    </div>
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultYScales.Scale3} field="yScale3.value" id="YScale3" />
                                    </div>
                                </div>

                                <h3>Y Arrow</h3>
                                <div className="row">
                                    <div className="col-xs-4">
                                        <Text className="form-control" placeholder={this.defaultYScales.Arrow} field="yArrow.value" id="YArrow" />
                                    </div>
                                </div>

                                <br />
                                <br />

                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        )}
                    </Form>}
                </PVAContentBody>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/9box/9boxSettings.tsx